import React, { Fragment, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import FContainer from "../../components/FContainer/FContainer";
import FCreditCard from "../../components/FCreditCard/FCreditCard";
import Fbutton from "../../components/Finputs/FButton/Fbutton";
import { useCards } from "../../hooks/useCards";

const CardDetailScreen = ({ param }) => {
  const parameters = useLocation();
  const { deleteCard } = useCards();
  const route = useNavigate();

  const nextScreen = async (id) => {
    const response = await deleteCard(id);
    if (response == true) {
      route(-1);
    } else {
      alert("Error al eliminar tarjeta");
    }
  };
  return (
    <>
      <FContainer>
        <FCreditCard
          checked={true}
          lastDigits={parameters.state.lastDigits}
          name={parameters.state.name}
          expMonth={parameters.state.expirationMonth}
          expYear={parameters.state.expirationYear}
          type={parameters.state.type}
        />
        <div className="w-[240px] xxs:w-[290px] smm:w-[350px] z-10 border-0">
          <Fbutton
            type="error"
            value="Eliminar tarjeta"
            onClick={() => {
              Swal.fire({
                showCloseButton: true,
                title: "Eliminar tarjeta",
                text: "¿Está seguro que desea eliminar esta tarjeta?",
                imageUrl: require("../../components/assets/images/pregunta.png"),
                imageWidth: 150,
                imageHeight: 150,
                imageAlt: "Custom image",
                confirmButtonColor: "#28a745",
                cancelButtonColor: "#dc3545",
                showCancelButton: true,
                confirmButtonText: "Aceptar",
                cancelButtonText: "Cancelar",
                reverseButtons: true,
              }).then((result) => {
                if (result.isConfirmed) {
                  nextScreen(parameters.state.id);
                }
              });
            }}
          />
        </div>
      </FContainer>
    </>
  );
};

export default CardDetailScreen;
